<div class="dialog-container">
    <h1 class="condensed dialog-title">Exporteer delen</h1>
    <div class="dialog-content">
        <div class="w-100">
            <div *ngIf="!exporting" class="pb-3">
                <p>Exporteer alle delen naar een Excel document.</p>
                <div *ngFor="let status of statuses; let i = index">
                    <mat-checkbox
                        [(ngModel)]="filter['status_' + status.id]"
                        [disabled]="filter['status_' + status.id + '_disable']"
                        [value]="status.id"
                        color="primary">
                        <span [innerHTML]="status['img'] | safeHtml"></span>
                        {{status.name}}
                        <ng-container *ngIf="statusCounts.has(status.id)">
                            ({{statusCounts.get(status.id)}})
                        </ng-container>
                    </mat-checkbox>
                </div>
            </div>
            <div *ngIf="exporting" class="w-100">
                Bezig met exporteren...
                <br><br>
                <mat-progress-bar class="w-100" mode="indeterminate"></mat-progress-bar>
                <br><br>
            </div>
        </div>
    </div>
    <div class="d-flex flex-wrap">
        <button (click)="onNoClick()" mat-button>Annuleren</button>
        <div class="spacer"></div>
        <button (click)="export()" cdkFocusInitial color="primary" mat-raised-button>Download Excel bestand</button>
    </div>
</div>
